import { render, staticRenderFns } from "./CardsStackGame.vue?vue&type=template&id=2bd8c87c&scoped=true&"
import script from "./CardsStackGame.vue?vue&type=script&lang=js&"
export * from "./CardsStackGame.vue?vue&type=script&lang=js&"
import style0 from "./CardsStackGame.vue?vue&type=style&index=0&id=2bd8c87c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8c87c",
  null
  
)

export default component.exports